// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2hb64","errors":"Errors_errors__2GqQo"};